/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_OfflineInputs */

const fr_vehicle_offline = /** @type {(inputs: Vehicle_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors-ligne`)
};

const en_vehicle_offline = /** @type {(inputs: Vehicle_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

/**
* | output |
* | --- |
* | "Offline" |
*
* @param {Vehicle_OfflineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_offline = /** @type {((inputs?: Vehicle_OfflineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_OfflineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_offline(inputs)
	return en_vehicle_offline(inputs)
});